import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const LINKS = [
  { to: '/federation/dashboard', label: 'Dashboard' },
  { to: '/federation/programs', label: 'Programs' },
  { to: '/federation/submissions', label: 'Submissions' },
  { to: '/federation/findings', label: 'Findings' },
  { to: '/federation/actions', label: 'Actions' },
  { to: '/federation/objectives', label: 'Objectives' },
  { to: '/federation/reviews', label: 'Reviews' },
  { to: '/federation/reports', label: 'Reports' },
  { to: '/federation/settings', label: 'Settings' },
];

export default function FederationNav() {
  const location = useLocation();

  return (
    <div className="bg-navy-800 border-b border-navy-700 print:hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav
          className="flex items-center gap-1 overflow-x-auto py-2 -mx-1 px-1"
          aria-label="Federation"
        >
          {LINKS.map(({ to, label }) => {
            const active =
              location.pathname === to || location.pathname.startsWith(`${to}/`);
            return (
              <Link
                key={to}
                to={to}
                aria-current={active ? 'page' : undefined}
                className={`shrink-0 px-3 py-1.5 rounded text-sm font-medium text-white transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${
                  active
                    ? 'bg-navy-700 opacity-100'
                    : 'opacity-80 hover:opacity-100 hover:bg-navy-900'
                }`}
              >
                {label}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
